(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["allergies-select"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data(
      'allergySelect',
      (allergyDefinition, max_select_allergies = null, passedVariableName = null) => ({
        allergyDefinition: allergyDefinition
          .sort(function (a, b) {
            if (a.name.includes('その他') && !b.name.includes('その他')) {
              return -1;
            } else if (!a.name.includes('その他') && b.name.includes('その他')) {
              return 1;
            }
            return 0;
          })
          .sort(function (a, b) {
            const aGroup = a.subgroup || 'A';
            const bGroup = b.subgroup || 'A';
            if (aGroup > bGroup) {
              return 1;
            } else {
              return -1;
            }
          }),
        groups: [
          '特定原料8品目',
          '穀物類',
          'ナッツ類',
          '果物',
          '野菜',
          'コーヒー・お茶',
          '花・ハーブ類',
          'スパイス',
          'その他',
        ],
        currentGroup: null,
        fixer: {
          ナッツ類: ['落花生', 'くるみ', 'アーモンド', 'カシューナッツ', 'マカダミア', 'ピスタチオ'],
          ベリー系: ['いちご', 'カシス', 'ブルーベリー', 'その他ベリー系'],
          お茶系: ['抹茶', '紅茶', 'ほうじ茶', '烏龍茶', '緑茶', 'その他お茶系'],
          ハーブ系: [
            'ミント・ハッカ',
            'ローズヒップ',
            'レモングラス',
            'カモミール',
            'レモンバーベナ',
            'バジル',
            'コリアンダー',
            'ローズマリー',
            'その他ハーブ系',
          ],
          柑橘類: ['みかん・オレンジ', 'レモン', 'ゆず', 'グレープフルーツ', 'その他柑橘系'],
        },
        child_customer_allergies: [],
        max_select_allergies: max_select_allergies || passedVariableName,
        init() {
          this.allergies = this.allergyDefinition.map((item, key, array) => {
            return item;
          });

          console.log(this.allergies);

          this.$watch('child_customer_allergies', (value, oldValue) => {
            for (const key in this.fixer) {
              if (Object.hasOwnProperty.call(this.fixer, key)) {
                // const element = this.fixer[key];
                if (this.child_customer_allergies.includes(key)) {
                  this.child_customer_allergies = this.child_customer_allergies
                    .concat(this.fixer[key])
                    .filter((allergy) => allergy !== key);
                }
              }
            }
            console.log(this.child_customer_allergies);
            console.log(this.max_select_allergies);
            console.log(this.child_customer_allergies.length > this.max_select_allergies);
          });
        },
      }),
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-egift"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('egiftModal', (attributes, has_egift_only) => ({
      has_egift_only,
      openModal: false,
      loading: false,
      attributes,
      stageLists: [
        {
          key: 'message',
          label: 'メッセージ',
          checked: false,
        },
        {
          key: 'confirm',
          label: '確認する',
          checked: false,
        },
      ],
      stage: 'message',
      formContents: [
        {
          key: 'e-GIFTニックネーム',
          label: 'ニックネーム',
          type: 'text',
          placeholder: 'くにゃんど',
          value: '',
          required: true,
          helper: 'お相手に表示するニックネームを10文字以内で入力してください',
          maxLength: 10,
        },
        {
          key: 'e-GIFTメッセージ',
          label: 'メッセージ',
          type: 'textarea',
          placeholder: '例：お誕生日おめでとう！',
          value: '',
          required: true,
          helper: 'お相手に表示するメッセージを100文字以内で入力してください。',
          maxLength: 100,
        },
        {
          key: 'e-GIFT受取期限切れ時の対応',
          label: '受け取り期限切れ時の対応',
          type: 'radio',
          value: '送る',
          options: [
            {
              label: '送る',
              value: '送る',
            },
            {
              label: 'キャンセル',
              value: 'キャンセル',
            },
          ],
          required: true,
          helper: '受取者が入力期限を過ぎた場合は購入者住所へ送付しますか',
        },
      ],
      get buttonText() {
        return this.stage === 'message' ? '次へ進む' : '登録する';
      },
      get filled() {
        return this.filteredFormContents
          .filter((formContent) => formContent.required)
          .every((formContent) => formContent.value);
      },

      get egiftCompleted() {
        return Object.entries(this.attributes).some(([key, value]) => key.startsWith('e-GIFT'));
      },
      get filteredFormContents() {
        return this.formContents.filter((formContent) =>
          this.has_egift_only ? formContent.key !== 'e-GIFT受取期限切れ時の対応' : true,
        );
      },
      init() {
        console.log({ attributes });

        this.formContents.forEach((formContent) => {
          if (this.attributes[formContent.key]) {
            formContent.value = this.attributes[formContent.key];
          }
        });

        if (this.egiftCompleted) {
          this.stage = 'confirm';
        }
      },
      async next() {
        const errors = [];
        this.filteredFormContents
          .filter((formContent) => formContent.maxLength)
          .forEach((formContent) => {
            if (formContent.value.length > formContent.maxLength) {
              errors.push(`${formContent.label}は${formContent.maxLength}文字以内で入力してください`);
            }
          });

        if (errors.length > 0) {
          alert(`${errors.join(', ')}`);
          return;
        }

        const currentStage = this.stageLists.find((stage) => stage.key === this.stage);
        currentStage.checked = true;

        if (this.stage === 'message') {
          this.stage = 'confirm';
        } else {
          this.loading = true;
          const formData = new FormData();
          const props = this.filteredFormContents.reduce((acc, formContent) => {
            // acc[formContent.key] = formContent.value;
            formData.append(`attributes[${formContent.key}]`, formContent.value);
            return acc;
          }, formData);

          const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              return data;
            });

          location.reload();

          this.loading = false;
          console.log(res);
          this.attributes = res.attributes;

          this.openModal = false;
        }
      },
      back() {
        this.stage = 'message';
      },
      async resetEgift() {
        const isOK = confirm('e-GIFTの設定がリセットされます。よろしいですか？');
        if (!isOK) {
          return;
        }

        const formData = new FormData();

        this.formContents.forEach((formContent) => {
          formData.append(`attributes[${formContent.key}]`, '');
        });

        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => console.log(data));

        location.reload();
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crowdfunding-comment-area"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', function () {
    window.Alpine.data('crowdfundingCommentArea', function () {
      return {
        showModal: false,
        loading: false,
        formContents: [
          {
            label: '投稿者名',
            name: 'comment[author]',
            type: 'text',
            placeholder: '投稿者名',
            required: true,
            value: null,
            help: '10文字以内で入力してください',
          },
          {
            label: '応援コメント本文',
            name: 'comment[body]',
            type: 'textarea',
            placeholder: '公開後は内容の変更はできません。',
            required: true,
            value: null,
            help: '公開後は内容の変更はできません。',
          },
          {
            label: 'メールアドレス',
            name: 'comment[email]',
            type: 'email',
            placeholder: '例：info@kurand.jp',
            required: true,
            value: null,
            help: 'こちらの項目は非公開となります。',
          },
        ],
        init() {},
        get filled() {
          return this.formContents
            .filter((content) => content.required)
            .every((content) => content.value && content.value?.length > 0);
        },
        commentForm: {
          ['x-ref']: 'commentFormRef',
          ['@submit.prevent'](e) {
            e.stopPropagation();
            e.preventDefault();

            console.log('submitForm', e);
            this.submitForm(e);
          },
        },
        async submitForm(e) {
          e.stopPropagation();
          e.preventDefault();
          this.loading = true;
          // console.log('submitForm', e);

          const errors = this.formContents.reduce((acc, curr) => {
            if (curr.required && (!curr.value || curr.value?.length === 0)) {
              acc.push(`${curr.label}は必須項目です`);
            }

            if (
              curr.type === 'email' &&
              !/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/.test(curr.value)
            ) {
              acc.push(`${curr.label}は正しいメールアドレス形式で入力してください`);
            }

            return acc;
          }, []);
          if (errors.length > 0) {
            alert(errors.join('\n'));
            this.loading = false;
            return;
          }

          const res = await fetch(this.$refs.commentFormRef.action, {
            method: 'POST',
            body: new FormData(this.$refs.commentFormRef),
          });
          console.log(res);
          const data = await res.text();
          console.log(data);
          this.loading = false;
          window.location.reload();
        },
      };
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-profile-area"] && !Shopify.designMode) return;
  try {
    const genres = {
    sake: '日本酒',
    fruit: '果実酒',
    umeshu: '梅酒',
    liqueur: 'リキュール',
    shochu: '焼酎',
    wine: 'ワイン',
    sour: 'サワーベース',
    gin: 'クラフトジン',
    whisky: 'ウイスキー',
    beer: 'クラフトビール',
  };

  document.addEventListener('alpine:init', () => {
    window.Alpine.data('customerProfile', (customerId, defaultCustomerData) => ({
      showProfileEditModal: false,
      loading: false,
      baseUrl: window.env.MODE === 'development' ? '/apps/kurand-product-review' : '/a/kurand-product-review',
      reviewCount: 0,
      helpfulPoint: 0,
      //   customerData: {},
      user_thumbnail_id: defaultCustomerData.user_thumbnail_id || null,
      user_thumbnail: defaultCustomerData.user_thumbnail || null,
      nickname: defaultCustomerData.nickname || null,
      genre_icon: defaultCustomerData.genre_icon || null,
      favorite_genre: defaultCustomerData.favorite_genre || [],
      profile_text: defaultCustomerData.profile_text || null,
      formContents: [
        {
          label: 'レビュー画像',
          name: 'user_thumbnail',
          help: '円形にトリミングされます',
          type: 'file',
          placeholder: '画像',
          required: false,
          multiple: false,
          max: 1,
          maxSize: 10 * 1024 * 1024,
          default: defaultCustomerData.user_thumbnail,
          value: [],
        },
        {
          label: 'ニックネーム',
          name: 'nickname',
          type: 'text',
          placeholder: 'ニックネーム',
          required: true,
          value: defaultCustomerData.nickname || null,
          help: '10文字以内で入力してください',
        },
        {
          label: 'アイコンにつけるマークを選ぶ',
          name: 'genre_icon',
          type: 'select',
          help: '1番好きなお酒を選ぼう！',
          value: defaultCustomerData.genre_icon || null,
          options: [
            {
              label: 'なし',
              value: null,
            },
            ...Object.entries(genres).map(([key, value]) => ({
              label: value,
              value: key,
            })),
          ],
        },
        {
          label: '好きなお酒のジャンル',
          name: 'favorite_genre',
          type: 'checkbox',
          required: true,
          value: defaultCustomerData.favorite_genre || [],
          options: Object.entries(genres).map(([key, value]) => ({
            label: value,
            value: key,
          })),
        },
        {
          label: '自己紹介',
          name: 'profile_text',
          type: 'textarea',
          placeholder: '自己紹介',
          required: false,
          value: defaultCustomerData.profile_text || null,
        },
      ],
      // testVal: 'shochu',
      get hasPrevious() {
        return this.pageCursors.length > 1;
      },
      init() {
        // if (customerId === 'self') {
        //   this.customerData = defaultCustomerData;
        // }
        this.getCustomerData();
      },
      getGenreLabel(genre) {
        return genres[genre];
      },
      getIconSvg(icon) {
        return SvgObj[icon] || '';
      },
      getCustomerData() {
        const queryParams = new URLSearchParams();
        queryParams.set('customer_id', decodeURIComponent(customerId));

        fetch(this.baseUrl + '/customer-profile?' + queryParams.toString())
          .then((response) => response.json())
          .then(({ data }) => {
            console.log(data);
            this.reviewCount = data.review_count;
            this.helpfulPoint = data.helpful_point;
            if (customerId !== 'self') {
              this.user_thumbnail = data.user_thumbnail;
              this.nickname = data.nickname;
              this.genre_icon = data.genre_icon;
              this.favorite_genre = data.favorite_genre;
              this.profile_text = data.profile_text;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },

      submit() {
        // console.log(this.upload_file)
        // return

        console.log(this.formContents);

        this.loading = true;

        const errors = this.formContents.reduce((acc, curr) => {
          if (curr.required && (!curr.value || curr.value?.length === 0)) {
            acc.push(`${curr.label}は必須項目です`);
          }

          return acc;
        }, []);

        if (errors.length > 0) {
          alert(errors.join('\n'));
          this.loading = false;
          return;
        }

        const body = this.formContents.reduce((acc, curr) => {
          if (curr.value) {
            acc[curr.name] = curr.value;
          }

          return acc;
        }, {});

        console.log(body);

        fetch(this.baseUrl + '/customer-profile?customer_id=self', {
          // 送信先
          method: 'post', // メソッド
          headers: {
            // ヘッダー指定
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...body,
            default_user_thumbnail_id: this.user_thumbnail_id || null,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('profile update failed');
            }
            return response.json();
          })
          .then((data) => {
            console.log(data);
            alert('プロフィールを更新しました');
            if (data?.data?.user_thumbnail_id) {
              this.user_thumbnail_id = data?.data?.user_thumbnail_id;
            }

            if (this.formContents.find((formContent) => formContent.name === 'user_thumbnail')?.value?.[0]?.url) {
              this.user_thumbnail = this.formContents.find(
                (formContent) => formContent.name === 'user_thumbnail'
              )?.value?.[0]?.url;
              console.log('this.user_thumbnail', this.user_thumbnail);
            }

            this.nickname = this.formContents.find((formContent) => formContent.name === 'nickname')?.value;
            this.genre_icon = this.formContents.find((formContent) => formContent.name === 'genre_icon')?.value;
            this.favorite_genre =
              this.formContents.find((formContent) => formContent.name === 'favorite_genre')?.value || [];
            this.profile_text = this.formContents.find((formContent) => formContent.name === 'profile_text')?.value;

            this.showProfileEditModal = false;
            console.log(this.formContents);

            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            alert('プロフィールの更新に失敗しました');
            this.loading = false;
          });
      },
      deleteExistThumbnail() {
        const check = confirm('削除すると初期画像に戻ります。本当に削除しますか？');
        if (!check) {
          return;
        }

        this.loading = true;
        fetch(this.baseUrl + '/delete-customer-thumbnail', {
          // 送信先
          method: 'post', // メソッド
          headers: {
            // ヘッダー指定
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            default_user_thumbnail_id: this.user_thumbnail_id || null,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            alert('アイコンを削除しました');
            this.user_thumbnail_id = null;
            this.formContents = this.formContents.map((formContent) => {
              if (formContent.name === 'user_thumbnail') {
                formContent.value = [];
                formContent.default = null;
              }
              return formContent;
            });
            this.user_thumbnail = null;
            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            alert('アイコンの削除に失敗しました');
            this.loading = false;
          });
      },
    }));

    window.Alpine.data('imageUploadSingle', () => ({
      images: [],
      isDragOver: false,

      handleDrop(event) {
        this.isDragOver = false;
        const files = Array.from(event.dataTransfer.files);
        this.processFiles(files);
      },

      handleFileSelect(event) {
        const files = Array.from(event.target.files);
        this.processFiles(files);
        // inputをリセット（同じファイルを再選択可能にする）
        event.target.value = '';
      },

      processFiles(files) {
        // 画像ファイルのみをフィルタリング
        const imageFiles = files.filter((file) => file.type.startsWith('image/'));

        imageFiles.forEach((file) => {
          // ファイルサイズ制限（10MB）
          // if (file.size > 1 * 1024 * 1024) {
          //   alert(`${file.name} は10MBを超えているため、アップロードできません。`);
          //   return;
          // }

          // 同じファイル名の重複チェック
          // if (this.images.some((img) => img.name === file.name)) {
          //     alert(`${file.name} は既にアップロードされています。`);
          //     return;
          // }

          const reader = new FileReader();
          reader.onload = async (e) => {
            const resizedImg = await this.resizeImg(e.target.result);
            console.log(e.target.result, resizedImg);

            this.images = [
              {
                name: file.name,
                type: file.type,
                size: file.size,
                url: resizedImg,
              },
            ];
          };
          reader.readAsDataURL(file);
        });

        if (imageFiles.length === 0 && files.length > 0) {
          alert('画像ファイルのみアップロード可能です。');
        }
      },

      removeImage(index) {
        this.images.splice(index, 1);
      },

      clearAll() {
        if (confirm('すべての画像を削除しますか？')) {
          this.images = [];
        }
      },

      formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      },

      resizeImg(imageData) {
        return new Promise((resolve, reject) => {
          const image = new Image();
          let resizedImg = null;
          image.onload = function () {
            const canvas = document.createElement('canvas');
            canvas.width = 300;
            canvas.height = 300;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, 300, 300);
            // console.log(canvas.toDataURL('image/png'));
            resizedImg = canvas.toDataURL('image/png');
            resolve(resizedImg);
          };

          image.src = imageData;
          // console.log(resizedImg);
          // return resizedImg;
        });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["egift-receive-area"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('egiftReceiveArea', (egift_id) => ({
      egift_id: egift_id,
      loading: false,
      lineItems: [],
      confirming: false,
      isFilled: false,
      isShipped: false,
      message: '',
      nickname: '',
      egift_expire_at: null,
      delivery_date: null,
      delivery_time: null,
      minDate: window.dayjs().businessDaysAdd(5, 'days'),
      maxDate: window.dayjs().businessDaysAdd(60, 'days'),
      app_path:
        window.env.MODE === 'development'
          ? '/apps/kurand-product-review/egift-receive'
          : '/a/kurand-product-review/egift-receive',
      formContents: [
        {
          key: 'last_name',
          label: '姓',
          is_half_width: true,
          type: 'text',
          placeholder: '例：山田',
          required: true,
          value: null,
        },
        {
          key: 'first_name',
          label: '名',
          is_half_width: true,
          type: 'text',
          placeholder: '例：太郎',
          required: true,
          value: null,
        },

        {
          key: 'zip',
          label: '郵便番号',
          is_half_width: true,
          type: 'text',
          placeholder: '例：0000000',
          required: true,
          value: null,
          validator: (value) => {
            if (!value) {
              return true;
            }
            // -ありでもなしでも対応できるようにする
            const reg = /^[0-9]{3}-?[0-9]{4}$/
            return reg.test(value);
          },
          isValid: true,
        },
        {
          key: 'province',
          origin_key: 'province_code',
          label: '都道府県',
          type: 'select',
          is_half_width: true,
          value: '北海道',
          options: [
            {
              label: '北海道',
              value: '北海道',
            },
            {
              label: '青森県',
              value: '青森県',
            },
            {
              label: '岩手県',
              value: '岩手県',
            },
            {
              label: '宮城県',
              value: '宮城県',
            },
            {
              label: '秋田県',
              value: '秋田県',
            },
            {
              label: '山形県',
              value: '山形県',
            },
            {
              label: '福島県',
              value: '福島県',
            },
            {
              label: '茨城県',
              value: '茨城県',
            },
            {
              label: '栃木県',
              value: '栃木県',
            },
            {
              label: '群馬県',
              value: '群馬県',
            },
            {
              label: '埼玉県',
              value: '埼玉県',
            },
            {
              label: '千葉県',
              value: '千葉県',
            },
            {
              label: '東京都',
              value: '東京都',
            },
            {
              label: '神奈川県',
              value: '神奈川県',
            },
            {
              label: '新潟県',
              value: '新潟県',
            },
            {
              label: '富山県',
              value: '富山県',
            },
            {
              label: '石川県',
              value: '石川県',
            },
            {
              label: '福井県',
              value: '福井県',
            },
            {
              label: '山梨県',
              value: '山梨県',
            },
            {
              label: '長野県',
              value: '長野県',
            },
            {
              label: '岐阜県',
              value: '岐阜県',
            },
            {
              label: '静岡県',
              value: '静岡県',
            },
            {
              label: '愛知県',
              value: '愛知県',
            },
            {
              label: '三重県',
              value: '三重県',
            },
            {
              label: '滋賀県',
              value: '滋賀県',
            },
            {
              label: '京都府',
              value: '京都府',
            },
            {
              label: '大阪府',
              value: '大阪府',
            },
            {
              label: '兵庫県',
              value: '兵庫県',
            },
            {
              label: '奈良県',
              value: '奈良県',
            },
            {
              label: '和歌山県',
              value: '和歌山県',
            },
            {
              label: '鳥取県',
              value: '鳥取県',
            },
            {
              label: '島根県',
              value: '島根県',
            },
            {
              label: '岡山県',
              value: '岡山県',
            },
            {
              label: '広島県',
              value: '広島県',
            },
            {
              label: '山口県',
              value: '山口県',
            },
            {
              label: '徳島県',
              value: '徳島県',
            },
            {
              label: '香川県',
              value: '香川県',
            },
            {
              label: '愛媛県',
              value: '愛媛県',
            },
            {
              label: '高知県',
              value: '高知県',
            },
            {
              label: '福岡県',
              value: '福岡県',
            },
            {
              label: '佐賀県',
              value: '佐賀県',
            },
            {
              label: '長崎県',
              value: '長崎県',
            },
            {
              label: '熊本県',
              value: '熊本県',
            },
            {
              label: '大分県',
              value: '大分県',
            },
            {
              label: '宮崎県',
              value: '宮崎県',
            },
            {
              label: '鹿児島県',
              value: '鹿児島県',
            },
            {
              label: '沖縄県',
              value: '沖縄県',
            },
          ],
        },
        {
          key: 'city',
          label: '市区町村',
          type: 'text',
          placeholder: '例：足立区',
          required: true,
          value: null,
        },
        {
          key: 'address1',
          label: '町名番地',
          type: 'text',
          placeholder: '例：梅島3-33-6',
          required: true,
          value: null,
        },
        {
          key: 'address2',
          label: '建物名・部屋番号など',
          type: 'text',
          placeholder: '例：エンブレム西新井4F',
          value: null,
        },
        {
          key: 'email',
          label: 'メールアドレス',
          type: 'email',
          placeholder: '例：example@example.com',
          required: true,
          value: null,
        },
        {
          key: 'phone',
          label: '電話番号',
          type: 'text',
          placeholder: '例：0000000000',
          required: true,
          value: null,
          isValid: true,
          validator: (value) => {
            if (!value) {
              return true;
            }
            // 電話番号のバリデーションはここで行う
            const phoneNum = value?.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, '');
            const reg = new RegExp('^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$');
            return reg.test(phoneNum);
          },
        },
        {
          key: 'delivery_date',
          label: 'お届け希望日',
          type: 'date',
          placeholder: '例：2025-01-01',
          value: null,
        },
        {
          key: 'delivery_time',
          label: 'お届け希望時間',
          type: 'select',
          value: null,
          options: [
            {
              label: '指定しない',
              value: '',
            },
            {
              label: '午前中',
              value: '午前中',
            },
            {
              label: '14時から16時',
              value: '14時から16時',
            },
            {
              label: '16時から18時',
              value: '16時から18時',
            },
            {
              label: '18時から20時',
              value: '18時から20時',
            },
            {
              label: '19時から21時',
              value: '19時から21時',
            },
          ],
        },
      ],
      agree: false,
      get filled() {
        return (
          this.formContents.filter((formContent) => formContent.required).every((formContent) => formContent.value) &&
          this.formContents
            .filter((formContent) => formContent.validator)
            .every((formContent) => formContent.isValid) &&
          this.lineItems
            .filter(
              (lineItem) =>
                lineItem.product?.tags?.includes('e-GIFT専用') && lineItem.gachaData?.custom_genre_numbers_total,
            )
            .every((lineItem) => Object.keys(lineItem.gachaProperties).length > 0) &&
          this.lineItems
            .filter(
              (lineItem) =>
                lineItem.product?.tags?.includes('e-GIFT専用') &&
                !lineItem.gachaData?.custom_genre_numbers_total &&
                lineItem.gachaData?.collectionHandleForSelects?.length > 0,
            )
            .every((lineItem) => lineItem.selectedVariants.every((selectedVariant) => selectedVariant?.id)) &&
          this.agree
        );
      },
      get formValues() {
        return this.formContents.reduce((acc, formContent) => {
          acc[formContent.key] = formContent.value;
          return acc;
        }, {});
      },
      init() {
        console.log(window.env.MODE);
        this.$watch('confirming', (value) => {
          window.scrollTo({
            top: document.getElementById('egift-receive-title').offsetTop - 100,
            behavior: 'smooth',
          });
        });

        fetch(`${this.app_path}/${this.egift_id}`)
          .then((response) => {
            if (!response.ok) {
              console.error('response.ok:', response.ok);
              console.error('esponse.status:', response.status);
              console.error('esponse.statusText:', response.statusText);
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            console.log(data);

            this.lineItems = data.lineItems;
            this.message = data.message;
            this.nickname = data.nickname;
            this.isFilled = data.isFilled;
            this.isShipped = data.isShipped;
            this.egift_expire_at = window.dayjs(data.egift_expire_at).format('YYYY年M月D日');
            this.delivery_date = data.delivery_date ? window.dayjs(data.delivery_date).format('YYYY年M月D日') : null;
            this.delivery_time = data.delivery_time || null;

            const attrMinDate = data.min_shipping_date;

            if (attrMinDate && dayjs(attrMinDate).isAfter(this.minDate)) {
              this.minDate = dayjs(attrMinDate);
            }

            const attrMaxDate = data.max_shipping_date;

            if (attrMaxDate && dayjs(attrMaxDate).isAfter(this.maxDate)) {
              this.maxDate = dayjs(attrMaxDate);
            }

            window.flatpickr('#delivery_date_input', {
              minDate: this.minDate.toDate(),
              maxDate: this.maxDate.toDate(),
              disableMobile: true,
              wrap: true,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      },
      next() {
        if (this.confirming) {
          this.submit();
        } else {
          this.confirming = true;
        }
      },
      submit() {
        this.loading = true;

        const gachaProperties = this.lineItems.reduce((acc, lineItem) => {
          if (Object.keys(lineItem.gachaProperties || {}).length > 0) {
            acc[lineItem.id] = lineItem.gachaProperties;
          }
          return acc;
        }, {});

        const selectedVariants = this.lineItems.reduce((acc, lineItem) => {
          if (lineItem.selectedVariants?.every((selectedVariant) => selectedVariant.id)) {
            acc[lineItem.id] = lineItem.selectedVariants.reduce((acc, selectedVariant, index) => {
              acc[`選択商品${index + 1}`] =
                `${selectedVariant?.variants.nodes[0].sku || ''}|${selectedVariant?.title || ''}`;
              return acc;
            }, {});
          }
          return acc;
        }, {});

        fetch(`${this.app_path}/${this.egift_id}`, {
          method: 'POST',
          body: JSON.stringify({
            gachaProperties,
            selectedVariants,
            ...this.formContents.reduce((acc, formContent) => {
              acc[formContent.key] = formContent.value;
              return acc;
            }, {}),
          }),
        })
          .then((response) => {
            if (!response.ok) {
              console.error('response.ok:', response.ok);
              console.error('esponse.status:', response.status);
              console.error('esponse.statusText:', response.statusText);
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            this.loading = false;
            this.isFilled = true;
            console.log(data);

            window.scrollTo({
              top: document.getElementById('egift-filled-area').offsetTop - 100,
              behavior: 'smooth',
            });
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
            alert('送信に失敗しました。カスタマーサポートにお問い合わせください');
          });
      },
      nl2br(str) {
        str = str.replace(/\r\n/g, '<br />');
        str = str.replace(/(\n|\r)/g, '<br />');
        return str;
      },
      async autoCompleteZipcode(key, value) {
        if (key !== 'zip') {
          return;
        }

        const query_params = new URLSearchParams({
          zipcode: value,
        });
        const data = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?${query_params}`).then((response) =>
          response.json(),
        );
        if (data?.results?.length > 0) {
          this.formContents.find((formContent) => formContent.key === 'province').value = data.results[0].address1;
          this.formContents.find((formContent) => formContent.key === 'city').value = data.results[0].address2;
          this.formContents.find((formContent) => formContent.key === 'address1').value = data.results[0].address3;
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["egift-share-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('egiftShare', (egiftId, customerName, egiftExpireAt) => ({
      openModal: false,
      get receiveUrl() {
        return `https://kurand.jp/pages/egift-receive/${egiftId}`;
      },
      get shareText() {
        const text = `${customerName}さんより、クランドのお酒のe-GIFTが届きました。

下記URLから内容を確認し、お届け先のご入力をお願いいたします。
${this.receiveUrl}

受け取り設定期限：${egiftExpireAt}`;

        return encodeURIComponent(text);
      },
      init() {
        console.log('egiftShare');
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-review-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('myReviewForm', (params) => ({
      reviews: [],
      baseUrl: 'https://kurand.jp/a/kurand-product-review',

      mapImages(review) {
        review.images = (review.image_names || []).map(
          (name) => `https://cdn.shopify.com/s/files/1/0075/9909/5863/files/${name}`,
        );
        return review;
      },

      pick(all, wanted, limit) {
        const byId = new Map(all.map((r) => [String(r.id), r]));
        const pinned = wanted.map((id) => byId.get(id)).filter(Boolean);
        const pinnedIds = new Set(pinned.map((r) => String(r.id)));
        let fallback = all.filter((r) => !pinnedIds.has(String(r.id)));
        if (params.minRate) fallback = fallback.filter((r) => r.rate >= params.minRate);
        if (params.onlyImage) fallback = fallback.filter((r) => r.image_names && r.image_names.length > 0);
        if (params.minHelpful) {
          fallback = fallback.filter((r) => (Number(r.helpful_point) || 0) >= params.minHelpful);
        }
        return pinned.concat(fallback).slice(0, limit).map((r) => this.mapImages(r));
      },

      async fetchListPage(productId, cursor, numItems) {
        const qs = new URLSearchParams({ product_id: String(productId) });
        if (numItems) qs.set('num_items', String(numItems));
        if (cursor) qs.set('cursor', cursor);
        const res = await fetch(this.baseUrl + '/reviews/list?' + qs.toString());
        return res.json();
      },

      missingIds(wanted, collected) {
        const have = new Set(collected.map((r) => String(r.id)));
        return wanted.filter((id) => !have.has(id));
      },

      async init() {
        if (!params.productId) return;
        const limit = params.limit || 6;
        const wanted = (params.reviewIds || []).map(String).filter((id) => id && id !== '');

        try {
          const pageSize = wanted.length ? 200 : undefined;
          const first = await this.fetchListPage(params.productId, null, pageSize);
          const collected = first.reviews || [];
          this.reviews = this.pick(collected, wanted, limit);

          if (!wanted.length) return;

          const stillMissing = this.missingIds(wanted, collected);
          let cursor = first.continueCursor;
          let hasNext = !!first.hasNext;
          let pages = 1;
          while (stillMissing.length && hasNext && cursor && pages < 10) {
            pages += 1;
            const data = await this.fetchListPage(params.productId, cursor, 200);
            const batch = data.reviews || [];
            collected.push(...batch);
            for (let i = stillMissing.length - 1; i >= 0; i--) {
              if (batch.some((r) => String(r.id) === stillMissing[i])) stillMissing.splice(i, 1);
            }
            hasNext = !!data.hasNext;
            cursor = data.continueCursor;
          }

          this.reviews = this.pick(collected, wanted, limit);
        } catch (error) {
          console.error('❌ myReviewForm Error:', error);
          this.reviews = [];
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-detail"] && !Shopify.designMode) return;
  try {
    // document.addEventListener('alpine:init', () => {});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data(
      'productForm',
      (
        variants,
        checkFlg,
        currentVariant = {},
        hasFreeShippingTag = false,
        freeShippingThreshold = 550000,
        hasNoshi = false,
        selectedSellingPlan = {},
        sellingPlanGroups = [],
      ) => ({
        variants: variants,
        currentVariant: currentVariant,
        checkFlg: checkFlg,
        hasFreeShippingTag: hasFreeShippingTag,
        freeShippingThreshold: freeShippingThreshold,
        selectedSellingPlanId: selectedSellingPlan?.id || sellingPlanGroups?.[0]?.selling_plans?.[0]?.id,
        sellingPlans: sellingPlanGroups?.[0]?.selling_plans || [],
        hasNoshi: hasNoshi,
        selectedOptions: {
          option1: currentVariant.option1,
          option2: currentVariant.option2,
          option3: currentVariant.option3,
        },
        quantity: 1,
        loading: false,
        get isFreeShipping() {
          return this.hasFreeShippingTag || Number(this.currentVariant?.price || 0) >= this.freeShippingThreshold;
        },
        isOptionValueAvailable(position, value) {
          return this.variants.some((v) => v[`option${position}`] === value && v.available);
        },
        init() {
          console.log(sellingPlanGroups, this.sellingPlans);
          this.$watch('selectedOptions', (newVal, oldVal) => {
            console.log(newVal, oldVal, this.variants);
            const currentVariant = this.variants.find((variant) => {
              return variant.options.every((option, index) => {
                return newVal[`option${index + 1}`] === option;
              });
            });
            this.currentVariant = currentVariant;
          });
        },
        async addCart(e) {
          this.loading = true;

          if (this.checkFlg) {
            const check = await this.$confirmAsync({
              title: 'ご注意事項',
              textList: [
                '決済完了後、必ず3日以内にフォームから写真と文字をご提出ください。期限を過ぎるとキャンセルとなります。',
                '商品納品後の描き直し・修正は承っておりません。その場合は新規注文（全額）としてのお手続きが必要です。',
              ],
            });

            if (!check) {
              this.loading = false;
              console.log('キャンセル');
              return;
            }
          }

          const errors = [];

          const form = new FormData(e.target);

          form.entries().forEach(([key, value]) => {
            if (key.includes('選択商品') && !value) {
              errors.push('選択商品を選択してください');
            }
          });

          if (errors.length > 0) {
            this.loading = false;
            alert(errors.join('\n'));
            return;
          }

          if (this.hasNoshi) {
            window.dispatchEvent(
              new CustomEvent('noshi-modal:open', {
                detail: { formData: form, quantity: this.quantity },
              }),
            );
            this.loading = false;
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            body: form,
          })
            .then((res) => res.json())
            .then((data) => {
              console.log(data);

              if (data.status === 422) {
                alert(data.message);
                this.loading = false;
                return;
              }

              this.loading = false;
              if (data?.id) {
                Alpine.store('cartModalObj').data = {
                  ...data,
                  added_quantity: this.quantity,
                };
              }
            })
            .catch((err) => console.error(err));
        },
      }),
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-area"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data(
      'myReviewForm',
      ({ productId, customerId, nickname }, isOmitted = false, loggedInCustomerId = null) => ({
        isOmitted,
        loggedInCustomerId,
        customerId,
        nickname,
        sortKeys: [
          {
            key: 'desc',
            label: '投稿が新しい順',
          },
          {
            key: 'asc',
            label: '投稿が古い順',
          },
          {
            key: 'rate_desc',
            label: '評価が高い順',
          },
          {
            key: 'rate_asc',
            label: '評価が低い順',
          },
        ],
        sort_by: 'desc',
        showReviewModal: false,
        loading: false,
        reviews: [],
        hasNext: false,
        continueCursor: null,
        pageCursors: [null],
        baseUrl: window.env.MODE === 'development' ? '/apps/kurand-product-review' : '/a/kurand-product-review',
        rateFilter: '絞り込みなし',
        isPrivateFilter: undefined,
        hasPrivateCommentFilter: undefined,
        showSpFilter: null,
        editingId: null,
        addingPointLoadingId: null,
        formContents: [
          {
            label: 'レビュータイトル',
            name: 'title',
            type: 'text',
            placeholder: 'タイトル',
            required: true,
            value: null,
            disabled: false,
            help: '20文字以内で入力してください',
          },
          // {
          //   label: '投稿者名',
          //   name: 'nickname',
          //   type: 'text',
          //   placeholder: '名前',
          //   required: false,
          //   value: null,
          //   disabled: false,
          // },
          {
            label: 'メールアドレス',
            name: 'email',
            type: 'email',
            placeholder: 'メールアドレス',
            required: true,
            value: null,
            hidden: loggedInCustomerId ? true : false,
            disabled: false,
          },
          {
            label: '点数',
            name: 'rate',
            type: 'select',
            value: 5,
            default: 5,
            options: [
              {
                label: '5点',
                value: 5,
              },
              {
                label: '4点',
                value: 4,
              },
              {
                label: '3点',
                value: 3,
              },
              {
                label: '2点',
                value: 2,
              },
              {
                label: '1点',
                value: 1,
              },
            ],
            required: true,
            disabled: false,
          },
          {
            label: 'レビュー本文',
            name: 'content',
            type: 'textarea',
            placeholder: 'レビュー本文',
            required: true,
            value: null,
            disabled: false,
            help: '公開後は内容の変更はできません。',
          },
          {
            label: 'レビュー画像',
            name: 'upload_file_base64',
            help: '最大3つまで登録できます。公開後は内容の変更はできません。',
            type: 'file',
            placeholder: '画像',
            required: false,
            multiple: true,
            max: 10,
            maxSize: 10 * 1024 * 1024,
            value: [],
            default: [],
            disabled: false,
          },
          {
            label: '自分用メモ',
            name: 'private_comment',
            help: '外部公開に設定しても、この項目は非公開のまま保護されます。個人用メモとしてご活用ください。',
            type: 'textarea',
            placeholder: '自分用メモ',
            required: false,
            value: null,
            disabled: false,
          },
          {
            label: '外部公開設定',
            name: 'is_private',
            type: 'radio',
            help: '※非公開の場合はポイントは付与されません',
            options: [
              {
                label: '公開',
                value: false,
              },
              {
                label: '非公開',
                value: true,
              },
            ],
            required: true,
            value: false,
            default: false,
            disabled: false,
          },
        ],
        get hasPrevious() {
          return this.pageCursors.length > 1;
        },
        init() {
          this.getReviews();

          this.$watch('rateFilter', (newVal, oldVal) => {
            this.pageCursors = [null];
            this.getReviews();
          });

          this.$watch('isPrivateFilter', (newVal, oldVal) => {
            this.pageCursors = [null];
            this.getReviews();
          });

          this.$watch('hasPrivateCommentFilter', (newVal, oldVal) => {
            this.pageCursors = [null];
            this.getReviews();
          });

          this.$watch('sort_by', (newVal, oldVal) => {
            this.pageCursors = [null];
            this.getReviews();
          });
        },
        async addPointReview(review) {
          console.log(window.Cookies.get('kurand_added_review_point_id_' + review.id));
          if (window.Cookies.get('kurand_added_review_point_id_' + review.id) == 1) {
            alert('連続で役に立ったボタンを押すことはできません');
            return;
          }

          this.addingPointLoadingId = review.id;
          const res = await fetch(this.baseUrl + '/reviews/' + review.id + '/add-point', {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          this.addingPointLoadingId = null;

          if (res.ok) {
            window.Cookies.set('kurand_added_review_point_id_' + review.id, 1, { expires: 1 });
            review.helpful_point = (review.helpful_point || 0) + 1;
          }
        },
        prevPage() {
          this.pageCursors.pop();
          this.getReviews();
        },
        nextPage() {
          this.pageCursors.push(this.continueCursor);
          this.getReviews();
        },
        nl2brEscaped(str) {
          if (!str) return '';
          const escaped = String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
          return escaped.replace(/\r\n|\r|\n/g, '<br />');
        },
        async getReviews() {
          const queryParams = new URLSearchParams();
          if (customerId) {
            queryParams.set('customer_id', decodeURIComponent(customerId));
          } else if (productId) {
            queryParams.set('product_id', productId);
          }

          if (this.rateFilter !== '絞り込みなし') {
            queryParams.set('rate', parseInt(this.rateFilter));
          }

          if (this.isPrivateFilter !== undefined) {
            queryParams.set('is_private', this.isPrivateFilter);
          }

          if (this.hasPrivateCommentFilter !== undefined) {
            queryParams.set('has_private_comment', this.hasPrivateCommentFilter);
          }

          if (this.sort_by !== 'desc') {
            queryParams.set('sort_by', this.sort_by);
          }

          if (this.pageCursors.length > 1) {
            queryParams.set('cursor', this.pageCursors[this.pageCursors.length - 1]);
          }

          fetch(this.baseUrl + '/reviews/list?' + queryParams.toString(), {
            method: 'get',
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((response) => response.json())
            .then(async (data) => {
              let shopifyProducts = [];

              if (this.customerId) {
                const productIds = data.reviews.map((review) => 'gid://shopify/Product/' + review.product_id);
                const uniqueProductIds = Array.from(new Set(productIds));

                shopifyProducts = await window.Alpine.store('storeFrontAPI')
                  .getProductByIDs(uniqueProductIds)
                  .then((data) => {
                    return data.data.nodes.filter((node) => node?.onlineStoreUrl);
                  });
              }

              this.reviews = data.reviews.map((review) => {
                if (review.image_names?.length > 0) {
                  review.images = review.image_names.map(
                    (image) => `https://cdn.shopify.com/s/files/1/0075/9909/5863/files/${image}`,
                  );
                } else if (review.images_urls?.length > 0) {
                  review.images = review.images_urls;
                }

                if (shopifyProducts.length > 0) {
                  const product = shopifyProducts.find(
                    (product) => product.id === 'gid://shopify/Product/' + review.product_id,
                  );
                  review.product = product;
                }

                return review;
              });
              if (isOmitted) {
                this.reviews = this.reviews.toSpliced(3);
              }

              this.hasNext = data.hasNext;
              this.continueCursor = data.continueCursor;

              if (!isOmitted) {
                window.scroll({
                  top: 0,
                  behavior: 'smooth',
                });
              }

              // this.$nextTick(() => {
              //   console.log(this.$refs.imageContainer);
              //   const viewer = new this.$store.viewer.viewer(this.$refs.imageContainer, {
              //     navbar:false,
              //     toolbar:false,

              //   });

              //   viewer.show();
              // });
            })
            .catch((error) => {
              console.error(error);
            });
        },
        editReview(review) {
          this.showReviewModal = true;
          this.formContents = this.formContents.map((formContent) => {
            if (formContent.name === 'upload_file_base64') {
              if (review.image_urls?.length > 0) {
                formContent.value = review.image_urls.map((image) => {
                  return {
                    url: image,
                  };
                });
              } else if (review.image_names?.length > 0) {
                formContent.value = review.image_names.map((image) => {
                  return {
                    url: `https://cdn.shopify.com/s/files/1/0075/9909/5863/files/${image}`,
                  };
                });
              }
            } else {
              formContent.value = review[formContent.name];
            }

            if (['private_comment', 'is_private'].includes(formContent.name)) {
              formContent.disabled = false;
            } else {
              formContent.disabled = true;
            }
            return formContent;
          });
          this.editingId = review.id;
        },
        submit() {
          this.loading = true;

          const body = this.formContents.reduce((acc, curr) => {
            if (!curr.disabled) {
              acc[curr.name] = curr.value;
            }
            return acc;
          }, {});

          if (this.nickname) {
            body.nickname = this.nickname;
          }

          let path = '/reviews/create';

          if (this.editingId) {
            path = '/reviews/update/' + this.editingId;
          }

          fetch(this.baseUrl + path, {
            // 送信先
            method: 'post', // メソッド
            headers: {
              // ヘッダー指定
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...body,
              product_id: productId,
            }), // 送信データをセット（ここでJSON形式に変換）
          })
            .then((response) => response.json())
            .then((data) => {
              if (this.editingId) {
                alert('レビューを更新しました');
              } else {
                alert('お声を聞かせいただき、ありがとうございます！');
              }

              this.showReviewModal = false;
              this.formContents.forEach((formContent) => {
                if (typeof formContent.default === 'undefined') {
                  formContent.value = null;
                } else {
                  formContent.value = formContent.default;
                }
              });

              if (!this.editingId) {
                this.getReviews();
              }

              this.loading = false;
            })
            .catch((error) => {
              console.error(error);
              if (this.editingId) {
                alert('レビューの更新に失敗しました');
              } else {
                alert('レビューの投稿に失敗しました');
              }
              this.loading = false;
            });
        },
      }),
    );

    window.Alpine.data('imageUpload', () => ({
      images: [],
      isDragOver: false,

      handleDrop(event) {
        this.isDragOver = false;
        const files = Array.from(event.dataTransfer.files);
        this.processFiles(files);
      },

      handleFileSelect(event) {
        const files = Array.from(event.target.files);
        this.processFiles(files);
        // inputをリセット（同じファイルを再選択可能にする）
        event.target.value = '';
      },

      processFiles(files) {
        // 画像ファイルのみをフィルタリング
        const imageFiles = files.filter((file) => file.type.startsWith('image/'));

        imageFiles.forEach((file) => {
          // ファイルサイズ制限（10MB）
          if (file.size > 3 * 1024 * 1024) {
            alert(`${file.name} は30MBを超えているため、アップロードできません。`);
            return;
          }

          // 同じファイル名の重複チェック
          if (this.images.some((img) => img.name === file.name)) {
            alert(`${file.name} は既にアップロードされています。`);
            return;
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            this.images.push({
              name: file.name,
              type: file.type,
              size: file.size,
              url: e.target.result,
            });
          };
          reader.readAsDataURL(file);
        });

        if (imageFiles.length === 0 && files.length > 0) {
          alert('画像ファイルのみアップロード可能です。');
        }
      },

      removeImage(index) {
        this.images.splice(index, 1);
      },

      clearAll() {
        if (confirm('すべての画像を削除しますか？')) {
          this.images = [];
        }
      },

      formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-images-area"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('productReviewImagesArea', (productId) => ({
      productId,
      baseUrl: window.env.MODE === 'development' ? '/apps/kurand-product-review' : '/a/kurand-product-review',
      images: [],
      init() {
        setTimeout(() => {
          if (this.$refs.imageContainer?.checkVisibility()) {
            this.getImageReviews();
          }
        }, 100);
      },

      async getImageReviews() {
        const queryParams = new URLSearchParams();
        queryParams.set('product_id', productId);

        fetch(this.baseUrl + '/reviews/images?' + queryParams.toString(), {
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.json())
          .then(async (data) => {
            console.log({ data });
            this.images = data.reviews
              .map((review) => review.image_names)
              .flat()
              .map((image) => `https://cdn.shopify.com/s/files/1/0075/9909/5863/files/${image}`)
              .slice(0, 10);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-share-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('shareButtons', (title, url) => ({
      title,
      url,
      open: false,
      init() {
        console.log('shareButtons');
      },
      async share() {
        this.open = true;
        // console.log('share');
        // await navigator.share({
        //   title: this.title,
        //   url: this.url,
        // });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-wishlist-btn"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.store('wishList', {
      isAdded: false,
    });

    window.Alpine.data('hundleWishList', (product, product_id, customerId, removeOnly) => ({
      isAdded: false,
      showPopup: false,
      product_id: null,
      app_path: '/a/wishlist/',
      init() {
        if (product) {
          this.product_id = product.id.replace('gid://shopify/Product/', '');
        } else {
          this.product_id = product_id;
        }

        if (removeOnly) {
          this.isAdded = true;
        }

        if (!customerId) {
          return;
        }

        // fetch(app_path, {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     method: 'GET',
        // }).then((response) => {
        //     return response.json();
        // }).then((res) => {
        //     if (res.length > 0) {
        //         this.isAdded = true;
        //     };
        // })
        //     .catch((error) => {
        //         console.error('There has been a problem with your fetch operation:', error);
        //     });
      },
      toggle() {},
      add() {
        if (!customerId) {
          this.$store.loginModal.shown = true;
          return;
        }

        if (removeOnly) {
          this.remove();
          return;
        }

        fetch(this.app_path + 'add', {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            product_id: this.product_id,
          }),
        })
          .then(async (response) => {
            const resToJson = await response.json();
            if (response.status == 201) {
              return alert(resToJson.message);
            }

            if (response.ok) {
              this.isAdded = true;
              this.showPopup = true;
              setTimeout(() => {
                this.showPopup = false;
              }, 2000);
            } else {
              console.log(resToJson?.message);
              if (resToJson?.message) {
                return alert(resToJson.message);
              } else {
                throw new Error('Network response was not ok');
              }
            }
            return null;
          })
          .catch((error) => {
            console.error('There has been a problem with your fetch operation:', error);
          });
      },
      remove() {
        fetch(this.app_path + 'remove', {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'DELETE',
          body: JSON.stringify({
            product_id: this.product_id,
          }),
        })
          .then((response) => {
            if (response.ok) {
              this.isAdded = false;
            } else {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.error('There has been a problem with your fetch operation:', error);
          });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('quantitySelector', (max = null, min = 1, disable) => ({
      count: min,
      min: min,
      max: max,
      disable: disable,
      minus() {
        this.count--;
        if (this.count < min) {
          this.count = min;
        }
      },
      plus() {
        this.count++;
        if (max && this.count > max) {
          this.count = max;
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shortcode-collection_in_magazine"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    if (window.Alpine.data && !window._blogCartBtnRegistered) {
      window._blogCartBtnRegistered = true;
      window.Alpine.data('blogCartBtn', (variantId) => ({
        loading: false,
        added: false,
        async addToCart() {
          this.loading = true;
          try {
            const formData = new FormData();
            formData.append('form_type', 'product');
            formData.append('id', variantId);
            formData.append('quantity', '1');
            formData.append('properties[_fromTemplate]', 'blog');

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            });
            if (res.ok) {
              this.added = true;
              if (typeof Cart !== 'undefined') Cart.update();
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.loading = false;
          }
        },
      }));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shortcode-product_in_blog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    if (window.Alpine.data && !window._blogCartBtnRegistered) {
      window._blogCartBtnRegistered = true;
      window.Alpine.data('blogCartBtn', (variantId) => ({
        loading: false,
        added: false,
        async addToCart() {
          this.loading = true;
          try {
            const formData = new FormData();
            formData.append('form_type', 'product');
            formData.append('id', variantId);
            formData.append('quantity', '1');
            formData.append('properties[_fromTemplate]', 'blog');

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            });
            if (res.ok) {
              this.added = true;
              if (typeof Cart !== 'undefined') Cart.update();
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.loading = false;
          }
        },
      }));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
